import { SET_ITEMS, REMOVE_BY_ID, SET_ERROR, ADD_ITEM, SET_ITEM } from '../mutation-types'

import Vue from 'vue'
import axios from 'axios'

import { add, remove } from '@/components/SelectPlanogram'

export default {
    namespaced: true,

    state: {
        data: [],
        meta: null,
        error: null
    },

    mutations: {
        [ADD_ITEM](state, data) {
            state.data.unshift(data)
            add(data)
        },

        [SET_ITEMS](state, { data, meta }) {
            state.data = data
            state.meta = meta
        },

        [REMOVE_BY_ID](state, id) {
            const index = state.data.findIndex(item => item.id === id)

            if (index !== -1) {
                state.data.splice(index, 1)
            }

            remove(id)
        },

        [SET_ERROR](state, error = null) {
            state.error = error
        },

        [SET_ITEM](state, item) {
            const id = item.id
            const index = state.data.findIndex(item => item.id === id)

            if (index !== -1) {
                Vue.set(state.data, index, item)
            }

            remove(id)
            add(item)
        }
    },

    actions: {
        async fetchAll({ commit }, params = {}) {
            try {
                let response = await axios.get('api/planograms', { params })
                commit(SET_ITEMS, response.data)
            } catch (error) {
                return false
            }

            return true
        },

        async remove({ commit }, id) {
            try {
                await axios.delete('api/planograms/' + id)
                commit(REMOVE_BY_ID, id)
            } catch (error) {
                return false
            }

            return true
        },

        async fetch(_, id) {
            try {
                const response = await axios.get(`api/planograms/${id}`)
                return response.data
            } catch (error) {
                return false
            }
        },

        async store({ commit }, { id = null, ...attributes }) {
            try {
                if (id) {
                    const response = await axios.put(`api/planograms/${id}`, attributes)
                    commit(SET_ITEM, response.data)

                    return response.data
                } else {
                    const response = await axios.post('api/planograms', attributes)
                    commit(ADD_ITEM, response.data)

                    return response.data
                }
            } catch (error) {
                if (error.response.status === 422) {
                    commit(SET_ERROR, error.response.data || {})
                }

                return false
            }
        }
    }
}
